<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-09-24 09:11:38
 * @LastEditors: Yehon He 1427749162@qq.com
 * @LastEditTime: 2025-03-09 00:39:25
-->
<template>
    <config-wrap :title="label">
        <custom-schema-template :schema="schema.attrs" v-model="control.curWidget.attrs"></custom-schema-template>
        <div class="mb10 f-grey f12">{{ mOptions.note }}</div>
        <div class="nav">
            <div class="nav-add mb10" @click="openDynamicLiveDialog">选择动态数据</div>
            <div class="nav-add mb10" @click="openDialog">选择数据源</div>
            <draggable v-model="mValue">
                <!-- 编译模式,插槽可供自定义拖拽组件入容器 -->
                <slot v-if="edit"></slot>

                <!-- 非编译模式，根据schema子类遍历数组单项组件 -->
                <template v-else>
                    <div v-for="item in mValue" :key="item.id" class="nav-item">
                        <component v-for="(val, key, index) in schema.child" :key="index"
                            :is="typeToComponent[val.type]" v-model="item[key]" v-bind="val">
                        </component>
                        <div class="nav-delete" @click="delItem(item.id)">x</div>
                    </div>
                </template>
            </draggable>
        </div>

        <el-dialog v-if="dialogVisible" :title="dialogTitle" :visible.sync="dialogVisible" :top="dialogTop"
            :width="dialogWidth">
            <video-list v-if="videoVisible" @onChangeSelection="handleSelectionChange"></video-list>
            <video-type-list v-if="typeVisible" ref="liveTypeRef"></video-type-list>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="done">确 定</el-button>
            </span>
        </el-dialog>
    </config-wrap>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";
import typeToComponent from "@/config/schema-template";
import { getLiveTypeList, getLiveList } from "@/api/material";
import VideoList from "@/pages/mall/material-center/components/VideoList.vue"
import VideoTypeList from "@/pages/mall/material-center/components/VideoTypeList.vue"
import { mapGetters } from "vuex";


export default {
    name: "SchemaVideo",

    mixins: [schemaMixin],

    components: {
        VideoList,
        VideoTypeList,
    },

    props: {
        label: {
            type: String,
            default: "",
        },
        edit: {
            type: Boolean,
            default: false,
        },
        schema: {
            type: Object,
            default: () => { },
        },
    },

    inject: ["control"],

    data() {
        return {
            typeToComponent,
            list: [],
            liveTypeList: [],
            liveType1: '',
            liveType2: '',
            customUrl: '/pages/index/live/detail',
            dialogVisible: false,
            dialogTitle: "选择数据源",
            isShowCustomData: true,
            sourceType: 'live',
            videoVisible: false,
            typeVisible: false,
        };
    },

    computed: {
        // isShowCustomData() {
        //     return this.control.curWidget.attrs.dataMode == 'custom';
        // },
        dialogWidth() {
            return this.isShowCustomData ? '1200px' : '300px';
        },
        dialogTop() {
            return this.isShowCustomData ? '5vh' : void 0;
        },
        secondTypeList() {
            return this.liveTypeList.find(item => item._id == this.control.curWidget.attrs.liveType1)?.child || [];
        },
        ...mapGetters(["project"]),
        customPages() {
            return this.project.pages;
        },
    },

    watch: {
        'control.curWidget.attrs.dataMode': {
            handler() {
                this.list = [];
            },
            deep: true,
        },
        dialogVisible(val) {
            if (!val) {
                this.liveVisible = false;
                this.videoVisible = false;
                this.typeVisible = false;
                this.list = [];
            }
        }
    },

    created() {
        this.initializeConfig();
    },

    methods: {
        initializeConfig() {
            if (!this.control.curWidget.attrs) {
                this.$set(this.control.curWidget, 'attrs', {
                    style: 'fixed',
                    max: '2',
                    showControls: true,
                    playMode: 'default',
                    showInfo: true,
                    loop: true,
                    dataSource: 'existing',
                    videoList: [],
                    tabs: []
                });
            } else {
                // 确保所有必需的属性都存在
                const defaults = {
                    style: 'fixed',
                    max: '2',
                    showControls: true,
                    playMode: 'default',
                    showInfo: true,
                    loop: true,
                    dataSource: 'existing',
                    videoList: [],
                    tabs: []
                };
                
                for (const key in defaults) {
                    if (!this.control.curWidget.attrs.hasOwnProperty(key)) {
                        this.$set(this.control.curWidget.attrs, key, defaults[key]);
                    }
                }
            }
        },

        openDynamicLiveDialog() {
            this.initializeConfig();
            this.dialogVisible = true;
            this.typeVisible = true;
        },

        openDialog() {
            this.initializeConfig();
            this.dialogVisible = true;
            this.videoVisible = true;
        },
        // todo: 获取直播分类列表
        async getliveType1() {
            const { status, data, message } = await getLiveTypeList({
                page: 1,
                pageSize: 100,
            });
            if (status == 10000) {
                this.liveTypeList = data.categories;
            } else {
                this.$message.error(message);
            }
        },

        async getliveList() {
            try {
                const { status, data, message } = await getLiveList({
                    category: this.liveType1,
                    subCategory: this.liveType2,
                    page: 1,
                    pageSize: this.mOptions?.limit || 8,
                });
                if (status == 10000) {
                    const customUrl = this.customUrl;
                    // const arr = data.filter((item) => item._id === this.subTypeId)[0]?.materials;
                    this.list = data.rooms.map((item) => {
                        return {
                            id: item._id,
                            title: item.title,
                            image: item.cover,
                            liveUrl: item.liveUrl,
                            watchCount: item.views,
                            jump: {
                                id: customUrl,
                                type: "custom",
                                param: item._id
                            }
                        };
                    });
                } else {
                    throw new Error(message);
                }
            } catch (error) {
                this.$message.error(error || '获取数据失败');
            }
        },

        // 自定义数据返回的回调
        handleSelectionChange(val) {
            this.list = val;
        },
        setVideoList() {
            const customUrl = this.customUrl;
            this.list = this.list.map((item) => {
                return {
                    ...item,
                    jump: {
                        id: customUrl,
                        type: "custom",
                        param: item.id
                    }
                };
            });
            this.mValue = this.mValue.concat(this.list);
            // 根据id去重
            this.mValue = Array.from(
                new Map(this.mValue.map(item => [item.id, item])).values()
            );
        },

        setLiveKeyword(){
            const checkedList = this.$refs.liveTypeRef.getCheckedList();
            this.control.curWidget.attrs.tabs = checkedList;
        },

        done() {
            if(this.typeVisible){
                this.mValue = []
                this.setLiveKeyword();
            }
            if(this.videoVisible){
                this.control.curWidget.attrs.tabs = void 0;
                this.setVideoList();
            }
            
            this.dialogVisible = false;
        },

        addItem() {
            if (this.mValue.length >= this.mOptions?.limit) {
                this.$notify({
                    title: "无法新增",
                    message: `最多只能添加${this.mOptions?.limit}条数据`,
                    type: "warning",
                });
                return;
            }

            this.mValue.push({
                id: this.$getRandomCode(6),
            });
        },

        delItem(id) {
            let i = this.mValue.findIndex((item) => item.id == id);
            this.mValue.splice(i, 1);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .config-item {
    margin-bottom: 10px !important;
}

.p10 {
    padding: 10px;
}

.ml-auto {
    margin-left: auto;
}

.flex-row {
    display: flex;
    flex-direction: row;
}

.flex-end {
    justify-content: flex-end;
}
</style>